import Vue, { VueConstructor } from 'vue'
import { Store } from 'vuex'
import { IState } from './store/types'

abstract class VueStrongClass extends Vue {
  $store!: Store<IState>
}

export default Vue as VueConstructor<VueStrongClass>
